import axios from '../../../axiosClient.js';

export async function beginImport(fileCount, signal) {
  const { data } = await axios.post(
    '/api/ecg-viewer/imports',
    { fileCount },
    { signal, timeout: 60000 }
  );
  return data.importId;
}
export async function endImport(importId) {
  await axios.delete(`/api/ecg-viewer/imports/${encodeURIComponent(importId)}`, { timeout: 10000 });
}
export async function uploadAndParse(file, signal, importId) {
  if (file.size > 2 * 1024 * 1024) throw new Error('File exceeds the 2 MiB limit');
  const { data } = await axios.post('/api/ecg-viewer/parse', file, {
    headers: { 'Content-Type': 'application/octet-stream', 'X-ECG-Import-Id': importId },
    signal,
    timeout: 60000,
  });
  return data;
}
